
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/car-parts/[make]/[model]/[city]",
      function () {
        return require("private-next-pages/car-parts/[make]/[model]/[city]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/car-parts/[make]/[model]/[city]"])
      });
    }
  